import CustomTable from '@/components/CustomTable/CustomTable.vue';
import CustomTabs from '@/components/CustomTab/CustomTab.vue';
import AdminNavBar from '@/components/AdminNavBar/AdminNavBar.vue';
import { API_BASE_URL } from "@/config";
import { validateToken } from '@/utils/auth';
import { format_date } from '@/utils/date_formatter';

const STATUS_MAP = {
  Pending: 'pending',
  Approved: 'approved',
  Deactivated: 'deactivated',
  Declined: 'declined'
};

export default {
  name: 'ClientApplications',
  components: {
    AdminNavBar,
    CustomTable,
    CustomTabs
  },
  data: () => ({
    currentTab: localStorage.getItem('applications_tab') || 'Pending',
    columns: [
      { label: 'Name', key: 'name_email' },
      { label: 'Application Status', key: 'application_status' },
      { label: 'Date Created', key: 'date_created' },
    ],
    tabs: [
      { label: 'Pending', value: 'Pending' },
      { label: 'Approved', value: 'Approved' },
      { label: 'Deactivated', value: 'Deactivated' },
      { label: 'Declined', value: 'Declined'}
    ]
  }),
  watch: {
    currentTab(newTab) {
      localStorage.setItem('applications_tab', newTab);
      localStorage.removeItem(`page_client_applications_${newTab}`);
    }
  },
  methods: {
    formatDate(date) {
      return format_date(date);
    },
    getApplications(page = 1, search = '') {
      const TOKEN = localStorage.getItem('token');
      const status = STATUS_MAP[this.currentTab];
      return new Promise((resolve, reject) => {
        let url = `${API_BASE_URL}/verify_api/verify_admin_api/get_user_applications_api/?page=${page}&status=${status}`;
        if (search) {
          url += `&search=${encodeURIComponent(search)}`;
        }
        $.ajax({
          url: url,
          method: 'GET',
          dataType: 'json',
          headers: {
            Authorization: `Token ${TOKEN}`
          },
          success: function(data) {
            resolve({
              count: data.count,
              results: data.results,
            });
          },
          error: function(xhr, status, error) {
            reject(error);
          }
        });
      });
    },
    view_pending_application(user_id) {
      window.location.href = this.$router.resolve({ name: 'view_pending_application', params: { user_id: user_id } }).href;
    },
    view_approved_application(user_id) {
      window.location.href = this.$router.resolve({ name: 'view_approved_application', params: { user_id: user_id } }).href;
    },
    view_deactivated_application(user_id) {
      window.location.href = this.$router.resolve({ name: 'view_deactivated_application', params: { user_id: user_id } }).href;
    },
    view_declined_application(user_id) {
      window.location.href = this.$router.resolve({ name: 'view_declined_application', params: { user_id: user_id } }).href;
    },
  },
  mounted() {
    if (!validateToken(this.$router)) {
        return;
    }
    this.getApplications();
  }
};
